import React from 'react'
import packageJson from '../../../../package.json'

export const SoftwareVersion = () => (
  <span>PLANTECTION Backend v{packageJson['version']}</span>
)

export default SoftwareVersion
